<template>
  <v-container class="cmpbk black--text" id="chkout-container">
    <!--      
   13 Souls Run APP v0.8.1
    Copyright (c) 2024 Blue Cover Six LLC / John Molt
    BCS grants Unlimited License to 13 Souls LLC and Jeff Von Molt -->
    <!-- One to pay a simple $20 Entry Fee
One to pay a $60 bundle fee (final price TBD, but includes a shirt and a medal)
One to pay/make a donation of any kind. -->

    <!-- cleint id  ATF2MqCIzTUeROKOMx0Lo42GbG5hWsyB_RmP4RLgFjp7EpAcJ1Wj82gi7YdPWykQY_UWi9KIC6F4kKie -->
    <!-- client secret EOel4VQoEJTLrK8kD85UJQGLJLN1B_fIW8oVgMtFAe2gF2Jvb7f_QrkcF0L-cmHCCQHn-Gmvuach0ibG -->
    <!-- apyment data tranfer Identity Token: 2Z4WIQBfk0-971VIgs-1ePKUCkCliu30wCBbiTzTSbA9E7xauWgc2nUT4wy -->

    <!-- live clien id  ARsANw-IHv9pr38UJNVCpCFIpwDdmEpcXZUsWmsH-X8Yg4GGPI-uVWeOV_O_528Vrr4zoCW3Nxijfw4L -->
    <!-- live secret EHd03YvrbAI1OvjBaz1VlVq6PHzE8JI9owQmeKwZlrPAqboCVfesQYpzpvO2DoeWpggMdBo3qQzw6TBa -->
    <h1 class="white--text">CHECKOUT</h1>
    <!-- <a
      class="white--text"
      href="https://www.paypal.com/ncp/payment/GP2C3MDWHJBPY"
      >Paypal</a
    > -->
    <v-container fluid class="px-0" light style="color:white;">
    <h4>To continue you must agree to the waiver below:</h4>
    <a
    style="color:white;"
      href="/13_SOULS_RUN_RELEASE_AND_WAIVER_OF_LIABILITY_AGREEMENT_2026.pdf"
      target="_blank"
    >
      Read Waiver Here
    </a>

    <v-checkbox
       dark
       hide-details
      v-model="showFinish"
      label="I have read, understood, and agree to the 13 SOULS RUN RELEASE AND WAIVER OF LIABILITY."
    ></v-checkbox>
  </v-container>
    <h2 v-if="showFinish" class="white--text mt-10">Minimum Donation to Run $20</h2>
    <paypal_button  v-if="showFinish"
      :import="totalImport1"
      :description="description1"
      @paypal_done="paypal_done"
    />

<v-btn class="mt-6" outlined color="white" @click="$emit('close')">
  Back to Registration
</v-btn>

    <!-- <v-btn color="primary" class="white--text" @click="ppdone"
      >Paypal done test</v-btn
    > -->
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
#chkout-container {
  max-width: 768px;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import paypal_button from "../components/paypal_button.vue";
export default {
  name: "checkout",
  components: {
    paypal_button,
  },
  mixins: [bus_common],
  // head: {
  //   script: [
  //     {
  //       type: "text/javascript",
  //       src: "https://www.paypalobjects.com/api/checkout.js",
  //     },
  //   ],
  // },
  data() {
    return {
      showFinish:false,
      amountRules: [
        (v) => !!v || "Amount is required",
        (v) => v >= 20 || "Amount must greater than $20",
      ],
      totalImport1: "20",
      totalImport2: "2",
      totalImport3: "3",
      description1: "$20 Donation 13 Souls Run",
      description2: "$60 Donation 13 Souls Run Bundle",
      description3: "My Donation 13 Souls Run",
    };
  },

  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    ppdone() {

      let self = this;
      let pl = {
        regstId: self.$store.state.regstId,
        amount: parseFloat(20),
      };
      // self.$emit("paypal_done", pl);
      this.paypal_done(pl);
    },
    init() {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
